// 开瓶存酒剩余容量字段
const FIELD_CM = 'centimeter' // 厘米

export default {
  FIELD_CM
}
